import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getRegisterPage } from '../../../modules/content/selectors';
import { open } from '../../../modules/modal/actions';
import backupContent from '../../../../resources/registerBackup.json';

const Register = ({ content, openRegistrationModal }) => {
  let registerContent;
  if (content) {
    registerContent = content;
  } else {
    registerContent = backupContent;
  }
  const { image: { src }, cta: { text: buttonText } } = registerContent;

  return (
    <div className="register" data-test-id="register">
      <div className="container--fixed register__background">
        <img className="register__image" src={src} />
        <button className="register__button" dangerouslySetInnerHTML={{ __html: buttonText }} onClick={openRegistrationModal} type="button" />
      </div>
    </div>
  );
};

Register.propTypes = {
  content: PropTypes.object,
  openRegistrationModal: PropTypes.func
};

const mapDispatchToProps = {
  openRegistrationModal: open.bind(null, {
    componentName: 'LinkAccountTerms',
    componentProps: {
      contentToDisplay: 'registration'
    }
  })
};

const mapStateToProps = (state) => ({
  content: getRegisterPage(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);
